import "core-js/modules/es.object.freeze";
export var THEME = Object.freeze({
  light: 'light',
  dark: 'dark'
});